import _Date$now from "@babel/runtime-corejs3/core-js/date/now";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import React from "react";
import { format, addYears } from "date-fns";
import { Select, Option } from "@xo-union/tk-component-fields";
import { SeasonName } from "./types.js";
export var SeasonDropdown = function SeasonDropdown(_ref) {
  var _ref$field = _ref.field,
    name = _ref$field.name,
    value = _ref$field.value,
    _ref$form = _ref.form,
    setFieldValue = _ref$form.setFieldValue,
    errors = _ref$form.errors;
  var state = errors.season ? 'invalid' : undefined;
  return /*#__PURE__*/React.createElement(Select, {
    "data-testid": "season-dropdown",
    name: name,
    value: value,
    state: state,
    label: "Season",
    onChange: function onChange(_ref2) {
      var option = _ref2.option;
      var newValue = option.value;
      setFieldValue(name, newValue);
    }
  }, /*#__PURE__*/React.createElement(Option, {
    value: SeasonName.Winter
  }), /*#__PURE__*/React.createElement(Option, {
    value: SeasonName.Spring
  }), /*#__PURE__*/React.createElement(Option, {
    value: SeasonName.Summer
  }), /*#__PURE__*/React.createElement(Option, {
    value: SeasonName.Fall
  }));
};
export var YearDropdown = function YearDropdown(_ref3) {
  var _context;
  var _ref3$field = _ref3.field,
    name = _ref3$field.name,
    value = _ref3$field.value,
    _ref3$form = _ref3.form,
    setFieldValue = _ref3$form.setFieldValue,
    errors = _ref3$form.errors;
  var yearsOutLimit = 5;
  var today = new Date(_Date$now());
  var years = _mapInstanceProperty(_context = _Array$from({
    length: yearsOutLimit
  })).call(_context, function (_, i) {
    return format(addYears(today, i), 'yyyy');
  });
  var state = errors.year ? 'invalid' : undefined;
  return /*#__PURE__*/React.createElement(Select, {
    "data-testid": "year-dropdown",
    name: name,
    value: value,
    state: state,
    onChange: function onChange(_ref4) {
      var option = _ref4.option;
      return setFieldValue(name, option.value);
    }
  }, _mapInstanceProperty(years).call(years, function (y) {
    return /*#__PURE__*/React.createElement(Option, {
      value: y,
      key: y
    });
  }));
};